import React, { createContext, useCallback, useContext, useState, useRef, useEffect } from 'react';

const PromptContext = createContext(null);

export function PromptProvider({ children }){
  const [state,setState]=useState({ open:false, title:'', message:'', placeholder:'', confirmLabel:'Confirmer', cancelLabel:'Annuler', resolve:null });
  const prompt = useCallback((opts={})=> new Promise(res=> {
    setState({ 
      open:true, 
      title:opts.title||'Saisir', 
      message:opts.message||'', 
      placeholder:opts.placeholder||'',
      confirmLabel:opts.confirmLabel||'Confirmer', 
      cancelLabel:opts.cancelLabel||'Annuler', 
      resolve:res 
    });
  }),[]);
  const onClose = useCallback(()=>{ state.resolve && state.resolve(null); setState(s=>({...s, open:false})); },[state]);
  const onConfirm = useCallback((value)=>{ state.resolve && state.resolve(value); setState(s=>({...s, open:false})); },[state]);
  return <PromptContext.Provider value={{ prompt }}>
    {children}
    {state.open && <PromptModal {...state} onCancel={onClose} onConfirm={onConfirm} />}
  </PromptContext.Provider>;
}

export function usePrompt(){
  const ctx = useContext(PromptContext);
  if(!ctx) throw new Error('usePrompt must be used within <PromptProvider>');
  return ctx.prompt;
}

function PromptModal({ title, message, placeholder, confirmLabel, cancelLabel, onCancel, onConfirm }){
  const [value, setValue] = useState('');
  const inputRef = useRef(null);
  
  useEffect(()=>{ 
    const el=inputRef.current; 
    if(el) {
      el.focus();
      el.select();
    }
  },[]);

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(value);
  };

  return <div role='dialog' aria-modal='true' className='fixed inset-0 z-[1200] flex items-center justify-center p-4'>
    <div className='absolute inset-0 bg-black/40 backdrop-blur-sm' onClick={onCancel} />
    <div className='relative w-full max-w-md rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-xl p-6 space-y-4'>
      <h2 className='text-lg font-semibold text-primary'>{title}</h2>
      {message && <p className='text-sm text-gray-600 dark:text-gray-300'>{message}</p>}
      <form onSubmit={handleSubmit} className='space-y-4'>
        <textarea
          ref={inputRef}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder={placeholder}
          rows={3}
          className='w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-sm bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100 focus:outline-none focus:ring-2 focus:ring-accent/50'
        />
        <div className='flex justify-end gap-3'>
          <button type="button" onClick={onCancel} className='px-3 py-1.5 text-sm rounded border border-gray-300 dark:border-gray-600 bg-gray-50 dark:bg-gray-700 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-accent/50'>
            {cancelLabel}
          </button>
          <button type="submit" className='px-3 py-1.5 text-sm rounded bg-accent text-white hover:bg-accent-dark focus:outline-none focus:ring-2 focus:ring-accent/50'>
            {confirmLabel}
          </button>
        </div>
      </form>
    </div>
  </div>;
}
